<template>
  <Pie
    v-bind="{ chartData, chartOptions }"
    :class="$style.base"
  />
</template>

<script
  setup
  lang="ts"
>
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { Pie } from 'vue-chartjs';
import { useThemeStore } from '@/stores/theme';

ChartJS.register(ArcElement, Tooltip, Legend);

const props = defineProps<{
  data: {
    id: number;
    name: string;
    count: number;
    color: string;
    totalPrice: number;
  }[];
}>();

const { theme } = useThemeStore();

const chartData = computed(() => ({
  labels: props.data.map((item) => item.name),
  datasets: [
    {
      data: props.data.map((item) => item.count),
      backgroundColor: props.data.map((item) => item.color),
      borderColor: theme === 'DARK' ? '#000000' : '#ffffff',
      hoverOffset: 4,
    },
  ],
}));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: false,
  },
};
</script>

<style
  lang="scss"
  module
>
.base, .base canvas {
  max-width: 100%;
}
</style>
